<div *ngIf="areSettingsLoaded" class="table-responsive">
  <adp-setting *ngIf="areSettingsLoaded" [key]="offer + '_SupportServices'"></adp-setting>

  <table class="table table-borderless" style="margin-bottom:50px;">
    <tbody>
      <tr *ngFor="let service of supportServices; let i = index">
        <th scope="row">
          <adp-label [labelKey]="service"></adp-label>
        </th>
        <td>
          <mat-icon [svgIcon]="'yes'"></mat-icon>
        </td>
      </tr>
      <tr class="desktop-view">
        <td *ngIf="!isSPOEEnabled || (isSPOEEnabled && isNative)">
          <adp-setting [key]="offer + '_URL'"></adp-setting>
          <button
            mat-stroked-button
            color="primary"
            *ngIf="buttonUrl"
            (click)="redirectToUrl()"
            class="mt-3"
            [gtmClick]="getViewLabel(offer + '_Button_Label')"
            [gtmLinkURL]="buttonUrl">
            <adp-label [labelKey]="offer + '_Button_Label'"></adp-label>
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<div class="row mobile-view" *ngIf="!isSPOEEnabled || (isSPOEEnabled && isNative)">
  <div class="col-12">
    <button
      mat-stroked-button
      color="primary"
      *ngIf="buttonUrl"
      (click)="redirectToUrl()"
      [gtmClick]="getViewLabel(offer + '_Button_Label')"
      [gtmLinkURL]="buttonUrl">
      <adp-label [labelKey]="offer + '_Button_Label'"></adp-label>
    </button>
  </div>
</div>
